import React from 'react';
import { Container, Wrapper } from 'src/components/Layout';
import classes from 'src/components/CmsPage/CmsArtworkPage.scss';
import { LazyImg } from 'src/hooks/useLazyLoad';
import { RichText } from 'src/components/RichText/RichText';

import { Svg } from '../Svg/Svg';

const data = require('./content/CmsArtwork.json');

export const CmsArtworkPage: React.FC = () => {
    const heroImage = require('../../../static/img/cms/generic-header.png');
    return (
        <div className={classes.container}>
            <section className={classes.header} style={{ backgroundImage: `url(${heroImage})` }}>
                <Container>
                    <div className={classes.headerContent}>
                        <h1 className={classes.headerTitle}>Artwork Guidelines</h1>
                        <p>
                            <b>
                                To avoid unnecessary delays and to ensure you receive the highest quality customisation,
                                please review our artwork guidelines below.
                            </b>
                        </p>
                        <p>
                            Our team will review your artwork before customisation and, should we identify any issues
                            with the file provided, we will contact you to discuss the available options before
                            proceeding.
                        </p>
                    </div>
                </Container>
            </section>
            <Wrapper variant="page-inner">
                <Container>
                    {data.artwork.map((item) => {
                        const { image, title, content, icon, subTitle } = item;
                        return (
                            <div key={item.title} className={classes.block}>
                                <figure className={classes.blockImage}>
                                    <LazyImg src={image} alt={title} />
                                </figure>
                                <div className={classes.blockContent}>
                                    <p className={classes.blockSubHeader}>
                                        <Svg name={icon} /> {subTitle}
                                    </p>
                                    <h2>{title}</h2>
                                    <RichText content={content} />
                                </div>
                            </div>
                        );
                    })}
                </Container>
            </Wrapper>
        </div>
    );
};
